import { ALLOWED_FILE_TYPES, ErrorCodes, ProcessingErrorCode, MAX_FILE_SIZE } from '../constants/index.esm.js';
import { OcrError, ErrorCategory } from '../errors/OcrError.esm.js';

/**
 * Generates a unique trace ID for request tracing
 * Format: trace-{timestamp}-{random-string}
 *
 * @returns A unique trace ID string
 */ function generateTraceId() {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 10);
    return `trace-${timestamp}-${randomString}`;
}
/**
 * Validates a file for OCR processing
 * @param file - The file to validate
 * @returns true if valid, throws OcrError if invalid
 */ function validateFile(file) {
    // Validate file type
    if (!file.type || !ALLOWED_FILE_TYPES.includes(file.type.toLowerCase())) {
        const mimeType = file.type || 'unknown';
        throw new OcrError({
            message: `Unsupported file type: ${mimeType}. Please upload PDF, PNG, JPG, or TIFF files only.`,
            code: ProcessingErrorCode.UNSUPPORTED_FORMAT,
            statusCode: ErrorCodes.BAD_REQUEST,
            category: ErrorCategory.VALIDATION,
            details: {
                fileType: file.type,
                fileName: file.name,
                allowedTypes: ALLOWED_FILE_TYPES
            }
        });
    }
    // Validate file size if available
    if (file.size !== undefined && file.size > MAX_FILE_SIZE) {
        console.log('File is invalid due to size:', file.name);
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        const maxSizeMB = (MAX_FILE_SIZE / (1024 * 1024)).toFixed(2);
        throw new OcrError({
            message: `File size (${fileSizeMB}MB) exceeds maximum allowed size of ${maxSizeMB}MB.`,
            code: ProcessingErrorCode.FILE_SIZE_EXCEEDED,
            statusCode: ErrorCodes.BAD_REQUEST,
            category: ErrorCategory.VALIDATION,
            details: {
                fileSize: file.size,
                maxFileSize: MAX_FILE_SIZE,
                fileName: file.name
            }
        });
    }
    console.warn('File is valid for OCR processing:', file.name);
    return true;
}

export { generateTraceId, validateFile };
